const dappLink = process.env.REACT_APP_DAPP_WEBSITE;
export const roadmapDataTime = [
    {
        percentageTitle: "March 1st",
        detailTitle: `Initial Launch`,
        detailSub: `The website is live! <br> Launching Medium Channel, Discord Server and Social Media Accounts. <br> Starting marketing activities.`,
        itemComplete: true,
        comments: ''
    },
    {
        percentageTitle: "March 17th",
        detailTitle: `Public Sale`,
        detailSub: `Suddenly Unicorns collection will be released`,
        itemComplete: true,
        comments: ''
    },
    {
        percentageTitle: "Q2",
        detailTitle: `Enhanced Token Pages`,
        detailSub: `Promise: Token pages will be eye candy, and as functional as possible.`,
        itemComplete: true,
        comments: `You can view <a href="${dappLink}tokens/1" target="_blank" rel="noreferrer noopener"> the token pages</a> on the dapp`
    },
    {
        percentageTitle: "Q3",
        detailTitle: `Personal Gallery`,
        detailSub: `Promise: There will be an extensive personal gallery for token holders to showcase their tokens.`,
        itemComplete: true,
        comments: `Our brand new dapp has this. You can view your <a href="${dappLink}wallet" target="_blank" rel="noreferrer noopener"> personal gallery</a>, or <a href="${dappLink}tokens" target="_blank" rel="noreferrer noopener"> view all minted tokens </a>` 
    },
    {
        percentageTitle: "Q4",
        detailTitle: `Suddenly Unicorns Marketplace Development`,
        detailSub: `Promise: An authentic marketplace implementation for Suddenly Unicorns will kick off.`,
        itemComplete: true,
        comments: 'Since creating a marketplace is an overkill for this limited amount of holders, we thought current marketplaces were more than sufficient. You can also use the custom marketplace created on <a href="https://suddenlyunicornscollection.x.rarible.com/" target="_blank" rel="noreferrer noopener"> Rarible </a>'
    }
];

